export default {
  GET_STATES_QUERY_SERVICE: Symbol.for('GET_STATES_QUERY_SERVICE'),
  STATE_REPOSITORY: Symbol.for('STATE_REPOSITORY'),
  ONBOARDING_CATALOG_STATE_STATE_MANAGER: Symbol.for('ONBOARDING_CATALOG_STATE_STATE_MANAGER'),
};
